import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [modal, setModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#1A0B10] text-[#8A8A8A] py-10 px-5 text-center text-sm" data-id="element-24">
        <div className="max-w-2xl mx-auto space-y-4" data-id="element-25">
          <p className="text-xs text-[#6A5A5A]" data-id="element-26">
            © {new Date().getFullYear()} El Manual de las Migajas. Todos los
            derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs" data-id="element-27">
            <button onClick={() => setModal('privacy')} className="text-[#8A8A8A] hover:text-[#C86B5E] transition-colors underline-offset-4 hover:underline" data-id="element-28">
              Política de Privacidad
            </button>
            <button onClick={() => setModal('terms')} className="text-[#8A8A8A] hover:text-[#C86B5E] transition-colors underline-offset-4 hover:underline" data-id="element-29">
              Términos y Condiciones
            </button>
            <a href="mailto:contacto@manualdelasmigajas.com" className="text-[#8A8A8A] hover:text-[#C86B5E] transition-colors underline-offset-4 hover:underline" data-id="element-30">
              Contacto
            </a>
          </div>
          <p className="text-[10px] text-[#5A4A4A] pt-2 max-w-md mx-auto leading-relaxed" data-id="element-31">
            Este producto es de carácter educativo y no sustituye atención
            psicológica profesional.
          </p>
        </div>
      </footer>

      <LegalModal open={modal === 'privacy'} onClose={() => setModal(null)} title="Política de Privacidad" data-id="element-32">
        <p className="text-xs text-[#8A8A8A] uppercase tracking-wider" data-id="element-33">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-34">
          1. Información que recopilamos
        </h3>
        <p data-id="element-35">
          Al comprar "El Manual de las Migajas" recopilamos únicamente los datos
          necesarios para procesar tu compra y entregarte el producto digital:
          nombre, correo electrónico e información de pago (procesada de forma
          segura por nuestra pasarela de pagos).
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-36">
          2. Uso de tu información
        </h3>
        <p data-id="element-37">Tu correo electrónico se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-38">
          <li data-id="element-39">Enviarte el enlace de descarga de tu manual.</li>
          <li data-id="element-40">Proporcionar soporte si tienes problemas con tu acceso.</li>
          <li data-id="element-41">Notificarte sobre actualizaciones del producto adquirido.</li>
        </ul>
        <p data-id="element-42">
          No vendemos, alquilamos ni compartimos tus datos personales con
          terceros.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-43">
          3. Confidencialidad
        </h3>
        <p data-id="element-44">
          Sabemos que este es un tema sensible. Tu compra es completamente
          discreta: el cargo en tu estado de cuenta aparece de forma genérica y
          nadie más sabrá del producto que adquiriste.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-45">4. Seguridad</h3>
        <p data-id="element-46">
          Tus datos están protegidos mediante conexiones cifradas (SSL/HTTPS).
          El procesamiento de pagos se realiza a través de proveedores
          certificados PCI-DSS.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-47">5. Cookies</h3>
        <p data-id="element-48">
          Utilizamos cookies básicas para el funcionamiento del sitio y métricas
          anónimas de uso. No usamos cookies para perfilarte ni para publicidad
          invasiva.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-49">
          6. Tus derechos (ARCO)
        </h3>
        <p data-id="element-50">
          Conforme a la Ley Federal de Protección de Datos Personales en
          Posesión de los Particulares, tienes derecho a Acceder, Rectificar,
          Cancelar u Oponerte al tratamiento de tus datos. Escríbenos a{' '}
          <span className="text-[#5C1A2B]" data-id="element-51">
            contacto@manualdelasmigajas.com
          </span>{' '}
          para ejercer estos derechos.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-52">
          7. Cambios a esta política
        </h3>
        <p data-id="element-53">
          Cualquier modificación se publicará en esta misma página con su fecha
          de actualización.
        </p>
      </LegalModal>

      <LegalModal open={modal === 'terms'} onClose={() => setModal(null)} title="Términos y Condiciones" data-id="element-54">
        <p className="text-xs text-[#8A8A8A] uppercase tracking-wider" data-id="element-55">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-56">
          1. Sobre el producto
        </h3>
        <p data-id="element-57">
          "El Manual de las Migajas" es un producto digital descargable en
          formato PDF de aproximadamente 20 páginas. Al completar tu compra,
          recibirás el acceso de descarga en el correo electrónico que
          proporcionaste.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-58">
          2. Precio y pago
        </h3>
        <p data-id="element-59">
          El precio del manual es de <strong data-id="element-60">$89 MXN</strong> (pesos mexicanos),
          pago único. El cobro se realiza mediante nuestra pasarela de pagos al
          momento de la compra.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-61">3. Entrega</h3>
        <p data-id="element-62">
          La entrega es digital e inmediata. Recibirás un correo con el enlace
          de descarga en cuanto tu pago sea confirmado. Si después de 15 minutos
          no has recibido el correo, revisa tu carpeta de spam o escríbenos.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-63">
          4. Política de reembolsos
        </h3>
        <p data-id="element-64">
          Debido a la naturaleza digital del producto (es descargable y
          accesible inmediatamente después de la compra),{' '}
          <strong data-id="element-65">no se aceptan devoluciones ni reembolsos</strong> una vez
          completada la transacción.
        </p>
        <p data-id="element-66">
          Si tienes algún problema con el acceso o la descarga, contáctanos y lo
          resolveremos a la brevedad.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-67">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-68">
          El contenido del manual está protegido por derechos de autor. Al
          comprarlo obtienes una licencia personal e intransferible para su uso.
          Queda prohibida su reventa, redistribución, copia o publicación
          parcial o total sin autorización escrita.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-69">
          6. Naturaleza del contenido
        </h3>
        <p data-id="element-70">
          "El Manual de las Migajas" es material educativo e informativo basado
          en experiencias y observaciones generales.{' '}
          <strong data-id="element-71">
            No constituye asesoramiento psicológico, terapéutico, legal ni
            profesional
          </strong>
          . Si atraviesas una crisis emocional, busca apoyo de un profesional de
          la salud mental certificado.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-72">
          7. Resultados
        </h3>
        <p data-id="element-73">
          Los resultados descritos en la página son referencias generales y
          pueden variar según la persona. No garantizamos resultados
          específicos, ya que dependen del compromiso y circunstancias
          individuales de cada lectora.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-74">
          8. Limitación de responsabilidad
        </h3>
        <p data-id="element-75">
          No somos responsables por decisiones que tomes basadas en el contenido
          del manual ni por consecuencias derivadas de su aplicación.
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-76">9. Contacto</h3>
        <p data-id="element-77">
          Para dudas sobre estos términos:{' '}
          <span className="text-[#5C1A2B]" data-id="element-78">
            contacto@manualdelasmigajas.com
          </span>
        </p>

        <h3 className="font-serif text-lg text-[#2D2D2D] pt-2" data-id="element-79">
          10. Legislación aplicable
        </h3>
        <p data-id="element-80">
          Estos términos se rigen por las leyes de los Estados Unidos Mexicanos.
          Cualquier controversia se someterá a los tribunales competentes.
        </p>
      </LegalModal>
    </>;
}